import {
  activityLogDarkImg,
  activityLogImg,
  callRecordDarkImg,
  callRecordImg,
  importExportDarkImg,
  importExportImg,
  leadDarkImg,
  leadsImg,
  projectDocumentDarkImg,
  projectDocumentsImg,
  projectInventoryDarkImg,
  projectInventoryImg,
  socialMediaDarkImg,
  socialMediaImg,
  staffTargetDark,
  staffTargetImg,
  tasksDarkImg,
  tasksImg,
  tokenDarkImg,
  tokenImg,
  userTeamDarkImg,
  userTeamImg,
} from "assets/images/features";
import {
  Analysis,
  Automation,
  BellCheck,
  BuildingProperty,
  ChatCommunication,
  CheckShield,
  Goal,
  PropertyDevelopers,
  RealEstate,
  RealTimeTracking,
  SalesMarketing,
  SalesPipeline,
  TeamCollaboration,
  TeamsLeader,
  TopPerformance,
} from "./assets";

export const CALENDLY_URL = "https://calendly.com/salespeedup-info";
export const BASE_URL = "https://salespeed.netlify.app";

export const ABOUT_US_CARDS_CONTENT = [
  {
    key: "1",
    title: "Our Vision",
    description:
      "To become the trusted digital infrastructure for the real estate and property industry, accelerating growth through automated, transparent, and seamless workflows.",
  },
  {
    key: "2",
    title: "Our Mission",
    description:
      "To empower real estate businesses with a unified platform that connects teams with customers, ensures transparency, and helps close deals faster.",
  },
  {
    key: "3",
    title: "Our Values",
    description:
      "We believe in transparency, efficiency, and customer-first innovation. Our approach is built on trust, simplicity, and delivering real results — helping real estate teams work smarter, collaborate better, and grow faster.",
  },
];

export const TARGET_AUDIENCE_DATA = [
  {
    img: RealEstate,
    title: "Real Estate Agents",
  },
  {
    img: PropertyDevelopers,
    title: "Property Developers",
  },
  {
    img: TeamsLeader,
    title: "Team Leaders & Managers",
  },
  {
    img: SalesMarketing,
    title: "Sales & Marketing Teams",
  },
];

export const Steps_CARDS_CONTENT = [
  {
    id: "1",
    title: "Capture Leads",
    description:
      "Collect inquiries from multiple sources - calls, website forms, ads, or social media - so no opportunity is missed.",
  },
  {
    id: "2",
    title: "Assign and Follow",
    description:
      "Distribute leads to the right team members and set follow-up tasks to ensure timely engagement.",
  },
  {
    id: "3",
    title: "Track Progress and Communicate",
    description:
      "Monitor task completion, track project progress, and maintain seamless communication with clients.",
  },
  {
    id: "4",
    title: "Manage Documents",
    description:
      "Attach project-related contracts, approvals, drawings, and other critical documents - all stored securely in one place.",
  },
  {
    id: "5",
    title: "Log Calls and Engage",
    description:
      "Record client calls, follow up efficiently, and run targeted campaigns to nurture opportunities.",
  },
  {
    id: "6",
    title: "Close Deals and Record Payments",
    description:
      "Finalize deals with complete transparency, track payments, and maintain accurate records for every transaction.",
  },
];

export const SALE_SPEED_FEATURES = [
  {
    title: "Lead Management",
    heading: "Never miss a lead. Convert every inquiry into an opportunity.",
    description:
      "Capture, assign, follow up, and convert every inquiry. No lead is forgotten. No opportunity is wasted.",
    image: leadsImg,
    darkImage: leadDarkImg,
  },
  {
    title: "Token Management",
    heading: "Track every payment. Build trust with complete transparency.",
    description:
      "Track payments, token status, and commitments confidently. Complete transparency for every transaction.",
    image: tokenImg,
    darkImage: tokenDarkImg,
  },
  {
    title: "Task Management",
    heading: "Tasks done on time, every time with smart tracking.",
    description:
      "Assign tasks, set deadlines, monitor progress. Nothing gets delayed. Nothing is overlooked.",
    image: tasksImg,
    darkImage: tasksDarkImg,
  },
  {
    title: "Inventory Management",
    heading:
      "Real-time property, unit, and pricing updates for confident sales teams.",
    description:
      "Real-time property, unit, and pricing updates. Your sales team always speaks with confidence.",
    image: projectInventoryImg,
    darkImage: projectInventoryDarkImg,
  },
  {
    title: "Document Management",
    heading:
      "All project documents in one place. Organized, secure, and accessible.",
    description:
      "Attach agreements, invoices, drawings, and reports to projects — secure, organized, and easily accessible.",
    image: projectDocumentsImg,
    darkImage: projectDocumentDarkImg,
  },
  {
    title: "Call Records",
    heading: "Every conversation counts. Nothing gets missed.",
    description:
      "Track every client call with notes. Follow up smarter, strengthen relationships, and stay accountable.",
    image: callRecordImg,
    darkImage: callRecordDarkImg,
  },
  {
    title: "Advertizing & Social",
    heading: "Turn ads into leads, and leads into deals with smart tracking.",
    description:
      "Capture leads from Facebook, Instagram, Whatsapp. Turn responses into real opportunities instantly.",
    image: socialMediaImg,
    darkImage: socialMediaDarkImg,
  },
  {
    title: "Import & Export",
    heading: "Your data, your control. Always accessible, always secure.",
    description:
      "Move data anytime for reporting, backups, or migration. Full control over your information, with ease and security.",
    image: importExportImg,
    darkImage: importExportDarkImg,
  },
  {
    title: "User Management",
    heading: "Grow your team without losing control.",
    description:
      "Define roles, control access, and scale securely. Keep operations smooth as your team grows, with clear permissions and oversight.",
    image: userTeamImg,
    darkImage: userTeamDarkImg,
  },
  {
    title: "Activity Logs",
    heading:
      "Stay informed, stay accountable. With complete activity visibility.",
    description:
      "Monitor all user activities, track updates, and ensure transparency across projects and tasks.",
    image: activityLogImg,
    darkImage: activityLogDarkImg,
  },
  // {
  //   title: "Reports & Analysis",
  //   heading: "Insights to drive smarter decisions. Backed by real-time data.",
  //   description:
  //     "Generate reports and analytics to optimize your business performance.",
  //   image: leadImg,
  // },
  {
    title: "Staff Targets & Performance",
    heading: "Set goals. Measure results. Achieve them consistently.",
    description:
      "Assign targets, track performance, and ensure accountability across sales and projects.",
    image: staffTargetImg,
    darkImage: staffTargetDark,
  },
];

export const Stats_Data = [
  { id: "1", label: "Lead captauring", value: 100 },
  { id: "4", label: "Team accountability", value: 100 },
  { id: "5", label: "Reduced manual work", value: 100 },
  { id: "6", label: "Transparency", value: 100 },
  { id: "7", label: "Real-time progress monitoring", value: 100 },
  { id: "8", label: "History tracking", value: 100 },
  { id: "3", label: "Faster deal closures", value: 70 },
  { id: "2", label: "Smarter, data-driven decisions", value: 50 },
];

export const Features_CARDS_CONTENT = [
  {
    id: 1,
    icon: BuildingProperty,
    text: "Built specifically for real estate workflows.",
  },
  {
    id: 2,
    icon: CheckShield,
    text: "Full transparency for owners, managers, and agents.",
  },
  {
    id: 3,
    icon: SalesPipeline,
    text: "Tracks every deal from first inquiry to final closure.",
  },
  {
    id: 4,
    icon: TeamCollaboration,
    text: "Creates alignment between sales, marketing, and operations.",
  },
  {
    id: 5,
    icon: Analysis,
    text: "Scales effortlessly as your business grows.",
  },
  {
    id: 6,
    icon: Automation,
    text: "Automates daily workflows to save time and boost efficiency.",
  },
  {
    id: 7,
    icon: RealTimeTracking,
    text: "Tracks sales agent activity and progress in real time.",
  },
  {
    id: 8,
    icon: TopPerformance,
    text: "Highlights top-performing team members with clear insights.",
  },
  {
    id: 9,
    icon: ChatCommunication,
    text: "Tracks all customer communication for consistent follow-ups.",
  },
  {
    id: 10,
    icon: BellCheck,
    text: "Prevents missed or forgotten customer interactions.",
  },
  {
    id: 11,
    icon: Goal,
    text: "Eliminates the risk of missed leads.",
  },
];

export const navItems = [
  { label: "Home", to: "/#home" },
  { label: "Features", to: "/#features" },
  { label: "Packages", to: "/#pricing" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const META_INFORMATION_DEFAULTS = {
  home: {
    title: "Sale SpeedUp - Real Estate CRM",
    ogTitle: "Sale SpeedUp | Real Estate CRM & Performance",
    ogDescription:
      "Sale SpeedUp is a Real Estate CRM & Performance System to manage leads, track sales, align teams, automate workflows, and close deals faster.",
    chonicalUrl: BASE_URL,
  },
  about: {
    title: "About Us | Sale SpeedUp",
    ogTitle: "About Us | Sale SpeedUp",
    ogDescription:
      "Sale SpeedUp is a real estate platform powered by industry experts and PhD researchers, delivering smart and reliable solutions for modern businesses.",
    chonicalUrl: `${BASE_URL}/about`,
  },
  contact: {
    title: "Contact Us | Sale SpeedUp",
    ogTitle: "Contact Us | Sale SpeedUp",
    ogDescription:
      "Reach out to us for any inquiries, feedback, or assistance. We're here to help! Email: info@salespeedup.com | WhatsApp: +923007886861 / +923007886862",
    chonicalUrl: `${BASE_URL}/contact`,
  },
};
